import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {TypeModel} from 'src/models/TypeModel';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';

@Component({
  selector: 'app-type-filter',
  templateUrl: './type-filter.component.html',
  styleUrls: ['./type-filter.component.scss']
})
export class TypeFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

    listTypeFilter: any[];

    @Input() typeData: any;
    @Input() typeSelected: TypeModel;

    constructor() {
      super();
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
      if ('typeData' in changes) {
        this.listTypeFilter = this.typeData;
        this.optionSelected = this.typeSelected ? this.typeSelected : null;
      }

      if (this.typeSelected) {
        this.optionSelected = this.typeSelected;
      }
    }

    ngOnDestroy(): void {
    }

  }
